<template lang="pug">
.input.field.js-input(value="item.value" v-bind:class="{ invalid: item.error} ")
    input(
        :id="item.id"
        :type="item.type"
        :placeholder="item.placeholder"
        :value="item.value"
        v-on="listeners"
    ).input__el.clr-blue-22.trs.js-input-el
    label {{item.label}}
    p.invalid.input__error.t-xxxs.clr-red-2.trs `{{item.errorText}}`
</template>

<script>
  const checkbox = {
    props: {
      item: {
        type: Object
      },
      value: {
        type: String,
        default: ''
      }
    },
    computed: {
      listeners () {
        return {
          // Pass all component listeners directly to input
          ...this.$listeners,
          // Override input listener to work with v-model
          input: event => this.$emit('input', event.target)
        }
      }
    }
  }

  export default checkbox 
</script>
